import React from "react";
import styles from "../HeaderFooter.module.css";
import logo from "../../../images/foqus_logo_shishka.png"; // ✅ Fix the path

export const Header = () => {
  return (
    <header className={styles.header}>
      <img src={logo} alt="FOQUS Logo" className={styles.logo} />
    </header>
  );
};

export default Header;
